import React, { useEffect, useRef } from 'react';
import Switch from 'react-switch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import './ParametersPanel.css';

const ParametersPanel = ({ showCities, showStreets, showPOI, onToggleShowCities, onToggleShowStreets, onToggleShowPOI, onClose }) => {
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="parameters-panel-overlay">
      <div className="parameters-panel" ref={panelRef}>
        <button className="close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2>Paramètres</h2>
        <div className="switch-container">
          <label data-tooltip-id="citiesTip" data-tooltip-content="Afficher ou masquer le nom des villes sur la carte">
            Villes
            <Switch
              onChange={onToggleShowCities}
              checked={showCities}
              offColor="#888"
              onColor="#0a74da"
            />
          </label>
          <label data-tooltip-id="streetsTip" data-tooltip-content="Afficher ou masquer le nom des rues et routes sur la carte">
            Rues/Routes
            <Switch
              onChange={onToggleShowStreets}
              checked={showStreets}
              offColor="#888"
              onColor="#0a74da"
            />
          </label>
          <label data-tooltip-id="poiTip" data-tooltip-content="Afficher ou masquer le nom des points d'intérêt sur la carte">
            POI
            <Switch
              onChange={onToggleShowPOI}
              checked={showPOI}
              offColor="#888"
              onColor="#0a74da"
            />
          </label>
          <Tooltip id="citiesTip" place="left" effect="solid" />
          <Tooltip id="streetsTip" place="left" effect="solid" />
          <Tooltip id="poiTip" place="left" effect="solid" />
        </div>
      </div>
    </div>
  );
};

export default ParametersPanel;
